const extractParentTalkId = (value) => {
    const id = String(value || '').trim();
    const match = id.match(/(?:^|_)P_([0-9]{10,11})$/);
    return match ? `P_${match[1]}` : '';
};

const escapeRegExp = (value) => String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const addAcademyPrefixOnce = (idValue, academyCodeValue) => {
    const id = String(idValue || '').trim();
    const academyCode = String(academyCodeValue || '').trim();
    if (!id || !academyCode) return id;

    const withoutRepeatedPrefix = id.replace(
        new RegExp(`^(?:${escapeRegExp(academyCode)}_)+`),
        ''
    );
    return `${academyCode}_${withoutRepeatedPrefix}`;
};

export const getCanonicalTalkUserId = (userInfo2, userInfo, academyCodeValue) => {
    const candidates = [
        userInfo2?.id2,
        userInfo2?.id,
        userInfo?.id2,
        userInfo?.id
    ];
    const parentTalkId = candidates.map(extractParentTalkId).find(Boolean);
    const isParent = userInfo2?.role === 'parent'
        || userInfo2?.kind === 'parent'
        || userInfo?.role === 'parent'
        || userInfo?.kind === 'parent';
    const academyCode = academyCodeValue || userInfo2?.acaCode || userInfo?.acaCode || '';

    if (isParent || parentTalkId) return addAcademyPrefixOnce(parentTalkId, academyCode);
    return addAcademyPrefixOnce(userInfo2?.id || userInfo?.id || '', academyCode);
};

export const getParentTalkIdByPhone = (value, academyCode) => {
    const phone = String(value || '').replace(/[^0-9]/g, '');
    return phone ? addAcademyPrefixOnce(`P_${phone}`, academyCode) : '';
};
